module.exports = __webpack_public_path__ + "media/images/Results-Negative-Antibodies-9a6b834136dce1b02724a48d614cf76c.png";